export default __webpack_public_path__ + "static/media/notifications_15.f6fbe95e.png";